var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status-badge",class:_vm.classes},[_c('div',{staticClass:"status-badge__label"},[_vm._v(_vm._s(_vm.computedLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }